import { RouteErrorBoundary } from 'es/app/components/layout/RouteErrorBoundary';
import { SiteRouteMap as siteMap } from 'es/app/views/site/RouteMap';
import { lazy } from 'react';
import { Route } from 'react-router';

const Processes = lazy(() => import('es/app/views/site/processes'));
const EditProcesses = lazy(() => import('es/app/views/site/processes/edit'));
const Variables = lazy(() => import('es/app/views/site/processes/edit/variables'));
const EditProcess = lazy(() => import('es/app/views/site/processes/edit/process/EditProcess'));
const EditMonitor = lazy(() => import('es/app/views/site/processes/edit/monitor/EditMonitor'));
const LocationHistory = lazy(() => import('es/app/views/site/processes/edit/location-history/search'));
const EditMonitorLocation = lazy(() => import('es/app/views/site/processes/edit/location-history/edit'));
const Api = lazy(() => import('es/app/views/site/processes/edit/api'));
const ProcessSchemas = lazy(() => import('es/app/views/site/processes/edit/processSchemas'));
const Arena = lazy(() => import('es/app/views/site/processes/edit/arena'));
const DataViewer = lazy(() => import('es/app/views/site/processes/edit/data-viewer'));
const VariableDataViewer = lazy(() => import('es/app/views/site/processes/edit/variables/VariableDataViewer'));
const ProcessVariableDialog = lazy(
    () => import('es/app/views/site/processes/edit/variables/edit/ProcessVariableDialog')
);
const ProcessDeletion = lazy(() => import('es/app/views/site/processes/edit/deletion'));
const NoiseClassifierProcessSchemaHistory = lazy(
    () =>
        import('es/app/views/site/processes/edit/processSchemas/edit/noiseClassifier/NoiseClassifierProcessSchemaHistory')
);
const EditNoiseClassifierProcessSchemaDefinition = lazy(
    () =>
        import('es/app/views/site/processes/edit/processSchemas/edit/noiseClassifier/EditNoiseClassifierProcessSchemaDefinition')
);

export function ProcessRoutes() {
    return (
        <Route path={siteMap.processes.root} element={<Processes />} ErrorBoundary={RouteErrorBoundary}>
            <Route path={siteMap.processes.root} element={<EditProcesses />}>
                <Route path={siteMap.processes.variables().root} element={<Variables />}>
                    {[siteMap.processes.variables().create(), siteMap.processes.variables().edit().root].map(path => (
                        <Route key={path} path={path} element={<ProcessVariableDialog />} />
                    ))}
                    <Route
                        key={siteMap.processes.variables().edit().dataViewer}
                        path={siteMap.processes.variables().edit().dataViewer}
                        element={<VariableDataViewer />}
                    />
                </Route>
                {[siteMap.processes.create(), siteMap.processes.edit(), siteMap.processes.clone()].map(path => (
                    <Route
                        key={path}
                        path={path}
                        element={
                            <>
                                <EditMonitor />
                                <EditProcess />
                            </>
                        }
                    />
                ))}

                <Route path={siteMap.processes.locationHistory().root} element={<LocationHistory />} />
                {[
                    siteMap.processes.locationHistory().edit().root,
                    siteMap.processes.locationHistory().create().root,
                ].map(path => (
                    <Route key={path} path={path} element={<EditMonitorLocation />} />
                ))}

                {[
                    siteMap.processes.api().root,
                    siteMap.processes.api().search(),
                    siteMap.processes.api().create(),
                    siteMap.processes.api().edit(),
                    siteMap.processes.api().transfer(),
                ].map(path => (
                    <Route path={path} key={path} element={<Api />} />
                ))}

                {[siteMap.processes.processSchemas().root, siteMap.processes.processSchemas().search()].map(path => (
                    <Route key={path} path={path} element={<ProcessSchemas />} />
                ))}
                {[siteMap.processes.processSchemas().edit().root].map(path => (
                    <Route key={path} path={path} element={<ProcessSchemas />}>
                        <Route
                            path={siteMap.processes.processSchemas().edit().root}
                            index
                            element={<EditNoiseClassifierProcessSchemaDefinition />}
                        />
                        <Route
                            path={siteMap.processes.processSchemas().edit().noiseClassificationHistory}
                            element={<NoiseClassifierProcessSchemaHistory />}
                        />
                    </Route>
                ))}
                {[siteMap.processes.processSchemas().create()].map(path => (
                    <Route key={path} path={path} element={<ProcessSchemas />}>
                        <Route
                            index
                            path={siteMap.processes.processSchemas().create()}
                            element={<EditNoiseClassifierProcessSchemaDefinition />}
                        />
                    </Route>
                ))}

                <Route path={siteMap.processes.arena().root} element={<Arena />} />
                <Route path={siteMap.processes.dataViewer().root} element={<DataViewer />} />
                <Route path={siteMap.processes.deletion().root} element={<ProcessDeletion />} />
            </Route>
        </Route>
    );
}
